/* ============================================================
   VoltEdge v2 — countdown (evergreen or fixed) + live viewers.
   Loaded BEFORE global.js so it claims the countdown elements
   and removes the data-countdown attribute, preventing the
   older handler in global.js from touching them.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Countdown: evergreen (auto-reset) or fixed date ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (cd) {
    var evergreenHours = parseFloat(cd.dataset.evergreen);
    var isEvergreen = !isNaN(evergreenHours) && evergreenHours > 0;
    var d = cd.querySelector('.cd-d'), h = cd.querySelector('.cd-h'),
        m = cd.querySelector('.cd-m'), s = cd.querySelector('.cd-s');

    /* claim this element so global.js skips it */
    cd.removeAttribute('data-countdown');

    function pad(n) { return String(n).padStart(2, '0'); }

    function evergreenEnd() {
      var key = 'cd_' + (cd.dataset.key || 'promo');
      var now = Date.now();
      var stored;
      try { stored = parseInt(localStorage.getItem(key), 10); } catch (e) { stored = NaN; }
      if (!stored || stored < now) {
        stored = now + evergreenHours * 3600 * 1000;
        try { localStorage.setItem(key, String(stored)); } catch (e) {}
      }
      return stored;
    }

    var end;
    if (isEvergreen) {
      end = evergreenEnd();
    } else {
      var parsed = new Date(cd.dataset.end);
      if (isNaN(parsed.getTime())) { cd.style.display = 'none'; return; }
      end = parsed.getTime();
    }

    var timer;
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (isEvergreen) { end = evergreenEnd(); diff = end - Date.now(); }
        else { cd.style.display = 'none'; clearInterval(timer); return; }
      }
      var sec = Math.floor(diff / 1000);
      if (d) d.textContent = pad(Math.floor(sec / 86400));
      if (h) h.textContent = pad(Math.floor(sec % 86400 / 3600));
      if (m) m.textContent = pad(Math.floor(sec % 3600 / 60));
      if (s) s.textContent = pad(sec % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ---------- Live viewers counter ---------- */
  document.querySelectorAll('[data-live-viewers]').forEach(function (el) {
    var num = el.querySelector('[data-live-count]');
    if (!num) return;
    var base = parseInt(el.dataset.base, 10);
    if (isNaN(base) || base < 1) base = 30;
    var lo = Math.max(4, base - 10);
    var hi = base + 12;
    var cur = base;
    function set(v) { cur = v; num.textContent = v; }
    set(base + (Math.floor(Math.random() * 7) - 3));
    setInterval(function () {
      var v = cur + (Math.floor(Math.random() * 7) - 3);
      if (v < lo) v = lo;
      if (v > hi) v = hi;
      set(v);
    }, 2500 + Math.floor(Math.random() * 1800));
  });
})();
